import React, { useEffect, useContext, useState } from 'react'
import { MyContext } from '..';
import { fetchOrganizationDetails } from "../services"
import placeholderImage from "../assets/images/organization.png"
import ReactMarkdown from 'react-markdown';
import { SlLocationPin } from "react-icons/sl";
import { FiLink } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { FaPhone } from "react-icons/fa6";
import Button from '../GitHubComponents/Button';

export default function Overview(props) {
  document.title = props.title
  const { backendUrl } = useContext(MyContext)
  const queryParameters = new URLSearchParams(window.location.search);
  const subscriberCode = queryParameters.get("subcode") || props.subCode
  const [overview, setOverview] = useState({})
  useEffect(() => {
    async function fetchOverview() {
      try {
        const res = await fetchOrganizationDetails(backendUrl, subscriberCode);
        setOverview(res.data)
      } catch (error) {
        console.error('Error fetching Users data:', error);
      }
    }
    fetchOverview();
  }, [backendUrl, subscriberCode]);
  return (
    <div className='overview-body'>
      <div className="overview-head">
        <div className="organization-image">
          <img src={placeholderImage} alt="" />
        </div>
        <h1 className="organization-heading">
          {overview.organization_name}
        </h1>
      </div>
      <div className="overview-middle my-5">
        <div className="organization-meta">
          <ul>
            <li>
              <SlLocationPin/>
              <span>{overview.address}</span>
            </li>
            <li>
              <FiLink/>
              <span>{overview.website}</span>
            </li>
            <li>
              <HiOutlineMail/>
              <span>{overview.email}</span>
            </li>
            <li>
              <FaPhone/>
              <span>{overview.phone_number}</span>
            </li>
          </ul>
        </div>
        <div className="organization-description">
          <ReactMarkdown>{overview.description}</ReactMarkdown>
        </div>
        <Button text={"Edit"} type={"button"}/>
      </div>
    </div>
  )
}
